import { Injectable } from "@nestjs/common";
import { AssetTransferRepository } from "../asset-transfers/repository/asset-transfers.repository";
import { AssetLicenseAdapter } from "./entity/asset-license.adapter";
import { AssetLicenseDto } from "./dto/asset-license.dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { AssetLicense } from "./entity/asset-license.entity";
import { Raw, getManager } from "typeorm";
import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { AssetLicenseRepository } from "./repository/asset-license.repository";
import { AssetsRequest } from "./dto/asset-license-active-inactive";
import { AssetLicenseLogsDto } from "./dto/license-log.dto";
import { AssetsRepository } from "../open-assets/dto/opens-assets-repository";
import { LicenseLogsAdapter } from "./entity/license-log.adapter";
import { LicenseLogRepository } from "./repository/license-log.repository";
import { assetsLogTransactions } from "./entity/license-log.entity";
import { AssetByStatus } from "../open-assets/dto/asset-by-status.dto";
import appSettings from "apps/services/config";

@Injectable()
export class AssetLicenseService{
    constructor(
        private assetLicenseRepository : AssetLicenseRepository,
        private licenseLogRepository:LicenseLogRepository,
        private assetAdapter : AssetLicenseAdapter,
        private assetTransferAdapter:LicenseLogsAdapter,
    ){}

    async createAssetLicense(assetLicenseDto: AssetLicenseDto, isUpdate: boolean = false): Promise<CommonResponse> {
        try {
            if (!isUpdate) {
                const assetsEntity = await this.getAssetLicense(assetLicenseDto.licenseNumber);
                if (assetsEntity) {
                    throw new ErrorResponse(11104, 'assetslicense already exists');
                }
            } else {
                const assetsEntity = await this.getAssetLicense(assetLicenseDto.licenseNumber);

                if (assetsEntity) {
                    if (assetsEntity.licenseId != assetLicenseDto.licenseId) {
                        throw new ErrorResponse(11104, 'assetslicense already exists');
                    }
                }
            }
            const assetsEntity: AssetLicense = this.assetAdapter.convertDtotoAssetLicenseEntity(assetLicenseDto, isUpdate);
            const savedAssetsLicenseEntity: AssetLicense = await this.assetLicenseRepository.save(assetsEntity);
            const savedAssetsLicenseDto: AssetLicenseDto = this.assetAdapter.convertEntitytoAssetLicenseDto(savedAssetsLicenseEntity);

            const transDto = new assetsLogTransactions()
       
            if (savedAssetsLicenseDto) {
                // transDto.licenseId=assetLicenseDto.licenseId
                transDto.licenseName = assetLicenseDto.licenseName;
                transDto.licenseNumber=assetLicenseDto.licenseNumber;
                transDto.renewalPersonName= assetLicenseDto.renewalPersonName;
                transDto.renewalExpiryDate= assetLicenseDto.renewalExpiryDate;
                transDto.renewalStartDate= assetLicenseDto.renewalStartDate;

                await this.licenseLogRepository.save(transDto)
                
                const response = new CommonResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'AssetsLicense Updated Successfully' : 'AssetsLicense Created Successfully', savedAssetsLicenseDto);
                return response;

            } else {
                throw new ErrorResponse(11106, 'assetLicense saved but issue while transforming into DTO');
            }

        }
        catch (error) {
            throw error;
        }
    }

    async getAssetLicense(licenseName: string): Promise<AssetLicense> {
        // tslint:disable-next-line: typedef
        const licenseResponse = await this.assetLicenseRepository.findOne({
          where: {licenseName: Raw(alias => `license_name = '${licenseName}'`)},
        });
        if (licenseResponse) {
          return licenseResponse;
        } else {
          return null;
        }
      }


    async getAllAssetsLicense(req?: AssetByStatus): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = ' SELECT c.certificate_name as certificateName,a.license_id AS licenseId ,a.license_name as licenseName ,reference_number AS referenceNumber,company,license_number AS licenseNumber,responsibility ,DATE(expiry_date) AS expiryDate ,a.is_active AS isActive,a.created_at AS createdAt,a.created_user,a.updated_at,a.updated_user,a.version_flag ,u.unit_name AS plantName,a.renewal_person_name AS renewalPersonName,a.renewal_start_date AS renewalStartDate,a.renewal_expiry_date AS renewalExpiryDate FROM '+appSettings.assets_db+'.asset_licence a LEFT JOIN '+appSettings.masters_db+'.`certificates` c ON certificate_id=a.license_name LEFT JOIN '+appSettings.masters_db+'.`unitcodes` u ON u.unit_code_id = a.plant'

            if (req.plantId > 0 && req.plantId != 5) {
                query = query + ' where a.plant = ' + req.plantId
            }
      const data=await manager.query(query)      
      if(data.length > 0){
        return new CommonResponse(true, 11208, "AssetsLicense retrieved successfully",data);
      }
      else{
            throw new ErrorResponse(99998, 'No Records Found');
      }
        } catch (err) {
            throw err;
        }
    }
    async getAllHistoryLicense(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = '  SELECT c.certificate_name AS certificateName,a.license_id AS licenseId ,a.license_name AS licenseName ,a.reference_number AS referenceNumber,a.company,a.license_number AS licenseNumber,a.responsibility ,DATE(a.expiry_date) AS expiryDate ,a.is_active AS isActive,a.created_at AS createdAt,a.created_user,a.updated_at,a.updated_user,a.version_flag ,u.unit_name AS plantName,ali.renewal_person_name,ali.renewal_start_date,ali.renewal_expiry_date FROM '+appSettings.assets_db+'.asset_licence a LEFT JOIN '+appSettings.masters_db+'.`certificates` c ON certificate_id=a.license_name LEFT JOIN '+appSettings.masters_db+'.`unitcodes` u ON u.unit_code_id = a.plant LEFT JOIN '+appSettings.assets_db+'.`asset_licence_transactions` ali ON ali.license_number = a.license_number ORDER BY ali.renewal_start_date DESC'

      const data=await manager.query(query)      
      if(data.length > 0){
        return new CommonResponse(true, 11208, "AssetsLicenseHistory retrieved successfully",data);
      }
      else{
            throw new ErrorResponse(99998, 'No Records Found');
      }
        } catch (err) {
            throw err;
        }
    }



    async getAssetsCatagoryData(licenseId: number): Promise<AssetLicense> {
        const response = await this.assetLicenseRepository.findOne({
            where: { licenseId: licenseId },
        });

        if (response) {
            return response;
        } else {
            return null;


        }
    }

    async activateorDeactivateLicense(AssetsCatagoryAct: AssetsRequest): Promise<CommonResponse> {
        try {
            const assetsExists = await this.getAssetsCatagoryData(AssetsCatagoryAct.licenseId);
            if (assetsExists) {
                if (AssetsCatagoryAct.versionFlag !== assetsExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current AssetsLicense information.Refresh and try again');
                } else {

                    const assetsSatatus = await this.assetLicenseRepository.update(
                        { licenseId: AssetsCatagoryAct.licenseId },
                        { isActive: AssetsCatagoryAct.isActive, updatedUser: AssetsCatagoryAct.updatedUser });
            
                    if (assetsExists.isActive) {
                        if (assetsSatatus.affected) {
                            const assetsResponse: CommonResponse = new CommonResponse(true, 10115, 'AssetsLicense is de-activated successfully');
                            return assetsResponse;
                        } else {
                            throw new ErrorResponse(10111, 'AssetsClassification is already deactivated');
                        }
                    } else {
                        if (assetsSatatus.affected) {
                            const assetcatResponse: CommonResponse = new CommonResponse(true, 10114, 'AssetsLicense is activated successfully');
                            return assetcatResponse;
                        } else {
                            throw new ErrorResponse(10112, 'assetsClassification is already  activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
}